module.exports = __webpack_public_path__ + "images/eaa7541479b2dcea243d598f10dda1d4-illu_dir_recessed3.png";